import { Link } from 'react-router-dom';
import { ArrowRight, Home as HomeIcon, Truck, Building2, Boxes, Warehouse, Sofa, Trash2, MapPinned, Globe } from 'lucide-react';
import { SERVICES } from '../data/content';
import SEO from '../components/SEO';
import { Reveal } from '../hooks/useReveal';

const ICONS = { Home: HomeIcon, Truck, Building2, Boxes, Warehouse, Sofa, Trash2, MapPinned, Globe };

export default function ServicesIndex() {
  return (
    <>
      <SEO title="Removals Services London — House, Office, Man and Van | Laraé Logistics"
        description="Our full range of removals and logistics services across London and the South East — house removals, man and van, office relocations, packing, storage, furniture delivery and waste disposal." />
      <section className="bg-forest text-white py-16 md:py-24">
        <div className="max-w-7xl mx-auto px-5 md:px-8 lg:px-12">
          <h1 className="font-outfit text-4xl md:text-5xl lg:text-6xl font-medium tracking-tight max-w-3xl">All our removals services.</h1>
          <p className="font-manrope text-base md:text-lg text-white/80 mt-5 max-w-2xl">Choose the service that fits your move. Every job is fully insured and quoted upfront.</p>
        </div>
      </section>
      <section className="py-16 md:py-24">
        <div className="max-w-7xl mx-auto px-5 md:px-8 lg:px-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {SERVICES.map((s, i) => {
            const Icon = ICONS[s.icon] || Truck;
            return (
              <Reveal key={s.slug} delay={i * 60}>
                <Link to={`/services/${s.slug}`} className="group block h-full bg-white border border-sand rounded-2xl p-7 hover:border-forest hover:shadow-md hover:-translate-y-0.5 transition-all">
                  <div className="w-12 h-12 rounded-xl bg-sand grid place-items-center mb-5 text-forest group-hover:bg-forest group-hover:text-white transition-colors"><Icon size={22} /></div>
                  <h2 className="font-outfit text-xl font-semibold text-ink">{s.title}</h2>
                  <p className="font-manrope text-sm text-ink/65 mt-2 leading-relaxed">{s.short}</p>
                  <div className="flex items-center gap-1.5 text-forest font-manrope text-sm font-medium mt-5 group-hover:gap-2.5 transition-all">Learn more <ArrowRight size={14} /></div>
                </Link>
              </Reveal>
            );
          })}
        </div>
      </section>
    </>
  );
}
